import script from "./CatalogBulkSearchView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogBulkSearchView.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogBulkSearchView.vue?vue&type=style&index=0&id=a2690884&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2690884"]])

export default __exports__